import { Typography, Table, Tag } from 'antd';
// import { useTheme } from 'utils/Theme';
import { CeoSubmittedFormType } from 'models/CeoSubmittedForm';
import { EnrollmentFormModel } from 'models/EnrollmentForm';
import { SurveyType } from 'models/Survey';
import {
  Diagnostic,
  Summary,
} from 'routes/Dashboard/Diagnostic/Diagnostic.props';
import UnfinishedEmail, {
  UnfinishedEmailProps,
} from '../UnfinishedEmail/UnfinishedEmail.view';
import { Container, Header, UnsubmittedEmailsContainer } from './HeatMap.style';
import React from 'react';
import {QUESTION_TYPE} from 'types/Enum';


export interface HeatMapProps {
  enrollmentForm?: EnrollmentFormModel;
  survey?: SurveyType;
  summary: Summary;
  ceoAnswer?: CeoSubmittedFormType;
  unsubmittedEmails: string[];
  getColorOfText: (percent: number) => string;
  unfinishedEmailProps: UnfinishedEmailProps;
  hideHeader?: boolean;
}

const HeatMap = (props: HeatMapProps): JSX.Element => {
  // const theme = useTheme();

  return (
    <Container>
      {/* Participants Answers */}
      {props.survey?.order.map((key) => (
        <div key={key} style={{ marginBottom: '40px' }}>
          <h4 className='heatmap-title'>{key}</h4>
          <Table
            dataSource={props.summary[key]?.diagnostics || []}
            pagination={false}
            onHeaderRow={(columns, index) => ({ className: 'heatmap-table-header' })}
            summary={() => (
              <>
                <Table.Summary.Row>
                  <Table.Summary.Cell index={0}>
                    Category Score
                  </Table.Summary.Cell>
                  <Table.Summary.Cell index={1}>
                    <Tag
                      color={props.getColorOfText(
                        props.summary[key]?.categoryScore
                      )}
                      style={{
                        padding: '4px 28px',
                        borderTopLeftRadius: '8px',
                        borderTopRightRadius: '8px',
                        borderBottomLeftRadius: '8px',
                        borderBottomRightRadius: '8px',
                      }}
                    >
                      {props.summary[key]?.categoryScore.toFixed(2)}%
                    </Tag>
                  </Table.Summary.Cell>
                </Table.Summary.Row>

                <Table.Summary.Row>
                  <Table.Summary.Cell index={0}>
                    Financial Impact
                  </Table.Summary.Cell>
                  <Table.Summary.Cell index={1}>
                    <Tag>
                      {props.summary[key]?.financialImpact.toLocaleString(
                        'en-US',
                        {
                          style: 'currency',
                          currency: 'USD',
                        }
                      )}
                    </Tag>
                  </Table.Summary.Cell>
                </Table.Summary.Row>
              </>
            )}
          >
            <Table.Column
              title="Question"
              dataIndex="question"
              key={key + 'question'}
              width="40%"
            />

            <Table.Column
              title="Favorable %"
              key={key + 'favorable%'}
              width="10%"
              render={({
                favorable,
                totalResponses,
                type,
                avgNumericScore = 0,
                question
              }: Diagnostic) => {
                const percent = (favorable / totalResponses) * 100;

                if (type == QUESTION_TYPE.Numeric) {
                  if (question.startsWith('')) {
                    return (
                      <Tag
                        style={{
                          padding: '4px 28px',
                          borderTopLeftRadius: '8px',
                          borderTopRightRadius: '8px',
                          borderBottomLeftRadius: '8px',
                          borderBottomRightRadius: '8px',
                        }}
                      >
                        {avgNumericScore.toFixed(2)}%
                      </Tag>
                    );
                  }
                  return (
                    <Tag
                      color={props.getColorOfText(avgNumericScore)}
                      style={{
                        padding: '4px 28px',
                        borderTopLeftRadius: '8px',
                        borderTopRightRadius: '8px',
                        borderBottomLeftRadius: '8px',
                        borderBottomRightRadius: '8px',
                      }}
                    >
                      {avgNumericScore.toFixed(2)}%
                    </Tag>
                  );
                }

                if (type == QUESTION_TYPE.Input) {
                  return (<Tag color="blue" style={{ height: '100%' }}>
                    Open Response
                  </Tag>);
                }

                return (
                  <Tag
                    color={props.getColorOfText(percent)}
                    style={{
                      padding: '4px 28px',
                      borderTopLeftRadius: '8px',
                      borderTopRightRadius: '8px',
                      borderBottomLeftRadius: '8px',
                      borderBottomRightRadius: '8px',
                    }}
                  >
                    {percent.toFixed(2)}%
                  </Tag>
                );
              }}
            />
            <Table.Column
              title="Total 4 or 5 Ratings"
              width="10%"
              key={key + 'favorable'}
              render={({ favorable, type }: Diagnostic) => {
                if (type == QUESTION_TYPE.Numeric) {
                  return <></>;
                }

                return favorable;
              }}
            />
            <Table.Column
              title="Total Responses"
              dataIndex="totalResponses"
              width="10%"
              key={key + 'totalResponses'}
            />
            <Table.Column
              title="Input Responses"
              dataIndex="inputResponses"
              key={key + 'inputResponses'}
              width="30%"
              render={(data: Array<string>) => (
                <ul>
                  {data.map((d, ndx) => (
                    <li key={key + 'inputResponses' + ndx}>{d}</li>
                  ))}
                </ul>
              )}
            />
          </Table>
        </div>
      ))}

      {/* CEO Answers */}
      <h4 className='heatmap-title'>Growth Potential (CEO Questionnaire Responses)</h4>
      <Table
        bordered
        pagination={false}
        dataSource={(props?.ceoAnswer?.questions || [])
          .filter(({question}) => question != 'What do they actually say?')
        }
        onHeaderRow={(columns, index) => ({ className: 'heatmap-table-header' })}
      >
        <Table.Column
          title="Question"
          dataIndex="question"
          width="400px"
          render={(value, _, ndx) => {
            if (ndx <= 18) return (<p>{ndx + 1}. {value}</p>);
            return (<p>{ndx}. {value}</p>);
          }}
        />
        <Table.Column
          title="Value"
          dataIndex="value"
          render={(value, _, ndx) => {
            if (ndx == 18) return (<p>A: {value}<br/><br/>B: {props?.ceoAnswer?.questions[ndx + 1].value}</p>);
            return (<>{value}</>);
          }}
        />
      </Table>
    </Container>
  );
};

export default HeatMap;
